import {
  BookOpen,
  Bot,
  CalendarCheck,
  CalendarDays,
  ChartNoAxesCombined,
  FileText,
  Inbox,
  LayoutList,
  type LucideIcon,
  PlugZap,
  ReceiptEuro,
  Settings,
  Users,
} from "lucide-react";

type NavigationPath =
  | "/w/$workspaceSlug/today"
  | "/w/$workspaceSlug/calendar"
  | "/w/$workspaceSlug/inbox"
  | "/w/$workspaceSlug/leads"
  | "/w/$workspaceSlug/customers"
  | "/w/$workspaceSlug/approvals"
  | "/w/$workspaceSlug/templates"
  | "/w/$workspaceSlug/wiki"
  | "/w/$workspaceSlug/settings"
  | "/w/$workspaceSlug/costs"
  | "/w/$workspaceSlug/statistics"
  | "/w/$workspaceSlug/integrations"
  | "/w/$workspaceSlug/team";

export type NavigationItem = {
  label: string;
  to: NavigationPath;
  icon: LucideIcon;
  /** Only owners and admins. */
  manage?: boolean;
  /** Not among the four tabs on the phone. */
  desktop?: boolean;
  /** Also highlighted on this page, reached from it. */
  activeOn?: NavigationPath;
};

/** The first level of the sidebar, in the owner's order (2026-10-20). */
export const navigation: NavigationItem[] = [
  { label: "Oggi", to: "/w/$workspaceSlug/today", icon: CalendarCheck },
  { label: "Calendario", to: "/w/$workspaceSlug/calendar", icon: CalendarDays, desktop: true },
  { label: "Posta in arrivo", to: "/w/$workspaceSlug/inbox", icon: Inbox },
  // Customer Care is reached from the Lead page.
  {
    label: "Lead",
    to: "/w/$workspaceSlug/leads",
    icon: LayoutList,
    activeOn: "/w/$workspaceSlug/customers",
  },
  { label: "Approvazioni", to: "/w/$workspaceSlug/approvals", icon: Bot },
  { label: "Template", to: "/w/$workspaceSlug/templates", icon: FileText },
  { label: "Wiki", to: "/w/$workspaceSlug/wiki", icon: BookOpen },
];

/** "Impostazioni" opens into these pages. */
export const settingsNavigation: NavigationItem[] = [
  { label: "Impostazioni", to: "/w/$workspaceSlug/settings", icon: Settings, manage: true },
  { label: "Costi", to: "/w/$workspaceSlug/costs", icon: ReceiptEuro, manage: true },
  {
    label: "Statistiche",
    to: "/w/$workspaceSlug/statistics",
    icon: ChartNoAxesCombined,
    manage: true,
  },
  { label: "Integrazioni", to: "/w/$workspaceSlug/integrations", icon: PlugZap, manage: true },
  { label: "Team", to: "/w/$workspaceSlug/team", icon: Users, manage: true },
];

export function visibleItems(items: NavigationItem[], manage: boolean): NavigationItem[] {
  return items.filter((item) => !item.manage || manage);
}

/** The four quick tabs at the bottom of the phone screen. */
export function mobileTabs(items: NavigationItem[]): NavigationItem[] {
  return items.filter((item) => !item.desktop).slice(0, 4);
}
